import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, isRef as _isRef, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-44c24ebf"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "virus-container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "" }, [
  /*#__PURE__*/_createElementVNode("h1", null, "欢迎使用安全云更新病毒库 "),
  /*#__PURE__*/_createElementVNode("p", null, "病毒库定期更新能及时识别新病毒、提高检测准确性并增强系统安全防护能力。")
], -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "私有云病毒库版本号", -1))
const _hoisted_4 = { class: "label-value" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "本地病毒库版本号", -1))
const _hoisted_6 = { class: "label-value" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "最近更新时间", -1))
const _hoisted_8 = { class: "label-value" }
const _hoisted_9 = {
  class: "cm-align-center",
  style: {"align-self":"flex-start"}
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "病毒库自动更新策略（联网时自动生效）", -1))
const _hoisted_11 = {
  key: 0,
  class: "label-value",
  style: {"margin-top":"0","padding":"0 10px"}
}
const _hoisted_12 = { key: 1 }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { style: {"color":"var(--cm-color-text-primary)","font-weight":"bold"} }, "更新日志", -1))
const _hoisted_14 = {
  class: "",
  style: {"background":"var(--cm-color-card-bg)","padding":"15px 15px 0","border-radius":"var(--el-border-radius-large) var(--el-border-radius-large) 0 0"}
}
const _hoisted_15 = {
  class: "cm-align-center",
  style: {"color":"var(--cm-color-text-regular)"}
}
const _hoisted_16 = {
  class: "cm-align-center",
  style: {"flex":"1"}
}
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "iconfont cm-icon-info",
  style: {"color":"#666","font-weight":"normal","font-size":"18px"}
}, null, -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "1.每天凌晨0点~1点是安全云生成病毒时间", -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, " 2.执行更新时间建议在凌晨2点~23点区间", -1))
const _hoisted_20 = {
  class: "cm-align-center",
  style: {"flex":"1"}
}
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "iconfont cm-icon-info",
  style: {"color":"#666","font-weight":"normal","font-size":"18px"}
}, null, -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "开启后，此功能仅在可连接外网情况下生效", -1))

import { useReflectiveInjector } from '@tanbo/vue-di-plugin'
import { CloudFeatureOffLineLibraryService, SubmitVirusRequestParams, VirusDatabaseInfoData, VirusLogRequestParams, VirusUpdateData } from './service'
import { onMounted, ref, watch, reactive } from 'vue'
import { useCmTableListRefresh } from '@/hooks/use-cm-table-list-refresh'
import { ElMessage, ElMessageBox } from 'element-plus'
import { DateType, FormActionType, FormSize, FormSizeType, FormType } from '@/components/cmForm/types'
import CmForm from '@/components/cmForm/index.vue'
import { formatHoursToHoursMinutes, formatMapToOptions } from '@/utils/tool'
import { Frequency, frequencyText, FrequencyValues, StateType, UpdateStateType, UpdateStatus, UpdateStatusColor, UpdateStatusIcon, UpdateStatusText, UpdateTypeText } from './types'
import { formatTimeStamp } from '@/utils/time'
import UpdateVirusVersion from './components/UpdateVirusVersion.vue'
import { useParseTime } from '@/hooks'
import { formLabelStyle } from '@/components/cmForm/globalOpt'
import CmPage from '@/components/cmTable/index.vue'
type EventType = 'updateVirusByHand' | 'updateVirusByOffLine' | 'updateConfig' | 'getVirusInfo' | 'reset' | 'updateVirusByLocal' | 'checkNetWork'
// 事件池

export default /*#__PURE__*/_defineComponent({
  __name: 'cloud-feature-offline-library',
  setup(__props) {

const formSize: FormSizeType = FormSize.Small
const formType = FormActionType.Form
const injector = useReflectiveInjector([CloudFeatureOffLineLibraryService])
const cloudFeatureOffLineLibraryService = injector.get(CloudFeatureOffLineLibraryService)
const virusInfo = ref({} as VirusDatabaseInfoData)
const visible = ref(false)
const disabled = ref(false)
const visibleLog = ref(false)
const flag = ref(false)
const tableRef = ref()
const { refreshList } = useCmTableListRefresh(tableRef)
const isLocal = ref(false)
const status = ref()
const netChecking = ref(false)
const title = ref('自动更新策略')
const resetForm = { timing_update_status: StateType.Allowed, frequency: Frequency.EVERY_DAY, start_minutes: '' } as SubmitVirusRequestParams
const form = ref(resetForm)
const queryForm = ref({ start_time: null, end_time: null } as VirusLogRequestParams)
// 获取病毒信息api
const getVirusDatabaseInfoApi = cloudFeatureOffLineLibraryService.getVirusDatabaseInfo.bind(cloudFeatureOffLineLibraryService)
// 病毒日志api
const getSampleUpdateTaskListLogApi = cloudFeatureOffLineLibraryService.getSampleUpdateTaskListLog.bind(cloudFeatureOffLineLibraryService)
// 更新病毒api
const updateVirusConfigSourceApi = cloudFeatureOffLineLibraryService.updateVirusConfigSource.bind(cloudFeatureOffLineLibraryService)
// 查看病毒库更新任务结果
const getSampleUpdateOfflineVirusStatusApi = cloudFeatureOffLineLibraryService.getSampleUpdateOfflineVirusStatus.bind(cloudFeatureOffLineLibraryService)
// 更新状态
const getSampleUpdateUpdateStateApi = cloudFeatureOffLineLibraryService.getSampleUpdateUpdateState.bind(cloudFeatureOffLineLibraryService)
// 手动在线更新
const getSampleUpdateOnlineUpdateApi = cloudFeatureOffLineLibraryService.getSampleUpdateOnlineUpdate.bind(cloudFeatureOffLineLibraryService)
// 在线更新前检查网络问题
const getApiPrivatizationauthNetCheckApi = cloudFeatureOffLineLibraryService.getApiPrivatizationauthNetCheck.bind(cloudFeatureOffLineLibraryService)
// 网络状态文案映射
const netStatusTextMap: Record<number, string> = {
  1: '无法连接外网',
  2: '网络正常',
  3: '网络不稳定',
  4: '能连外网但连不了后台/下载地址',
}
/** 检查网络状态，返回 true 表示网络正常 */
async function checkNetWork (silent = false): Promise<boolean> {
  netChecking.value = true
  try {
    const result = await getApiPrivatizationauthNetCheckApi()
    const statusText = netStatusTextMap[result.status] || '未知网络状态'
    if (result.status === 2) {
      if (!silent) {
        ElMessage.success(`网络检测结果：${statusText}`)
      }
      return true
    }
    ElMessage.warning(`网络检测结果：${statusText}，${result.status === 3 ? '更新可能受到影响' : '无法进行在线更新'}`)
    return false
  } catch {
    ElMessage.error('网络检测失败，请稍后重试')
    return false
  } finally {
    netChecking.value = false
  }
}
// 列表配置
const tableOpt = reactive({
  bodyStyle: 'padding:0;background: transparent;border-radius:var(--el-border-radius-large)',
  containerOpt: { style: 'padding: 0 15px;background: var(--cm-color-card-bg)' },
  height: '100%',
  disabled: false,
  path: 'data',
  showActionBar: false,
  showForm: false,
  showRightToolbar: false,
  rowKey: 'execution_time',
  selection: false,
  columns: [
    {
      label: '更新时间',
      prop: 'execution_time',
      formatter: (_row, value) => formatTimeStamp(value, 'YYYY-MM-DD HH:mm'),
    },
    { label: '更新类型', prop: 'update_type', formatter: (_row, value) => UpdateTypeText[value] },
    { label: '更新状态', prop: 'status' },
    { label: '执行描述', prop: 'description' },
  ],
})
// 表单配置项
const formColumns = ref({
  timing_update_status: {
    label: '自动更新',
    labelSlot: true,
    type: FormType.Switch,
    colOpt: { span: 24 },
    switchOpt: {
      'active-value': 1,
      'inactive-value': 2
    },
  },
  frequency: {
    label: '定时频率',
    colOpt: { span: 24 },
    required: true,
    disabled: () => { },
    type: FormType.Select,
    dictData: formatMapToOptions(frequencyText, true),
  },
  start_minutes: {
    required: true,
    labelSlot: true,
    disabled: () => { },
    label: '执行时间',
    colOpt: { span: 24 },
    type: FormType.TimeSelect,
    timeSelectOpt: {
      clearable: false,
      start: '02:00',
      step: '00:15',
      end: '23:00',
    }
  }
})
// 日志查询字段配置项
const QueryFormColumns = ref({
  date: {
    formItemOpt: { class: 'date-label' },
    colOpt: { style: 'flex:0 0 260px' },
    hiddenAllLabel: true,
    type: FormType.Date,
    dateType: DateType.DateRange,
    events: {
      change: (val) => {
        const [start, end] = useParseTime(val)
        queryForm.value.start_time = start
        queryForm.value.end_time = end
        void refreshList()
      },
    },
    dateOpt: {
      'value-format': 'YYYY-MM-DD',
      'start-placeholder': '开始时间',
      'end-placeholder': '结束时间',
      clearable: true,
    },
  },
  update_type: {
    colOpt: { style: 'flex: 0 1 180px' },
    hiddenAllLabel: true,
    type: FormType.Select,
    placeholder: '更新类型',
    selectOpt: {
      clearable: true,
    },
    events: {
      change: () => { void refreshList() },
    },
    dictData: formatMapToOptions(UpdateTypeText, true),
  },
  status: {
    colOpt: { style: 'flex: 0 1 180px' },
    hiddenAllLabel: true,
    type: FormType.Select,
    placeholder: '更新状态',
    selectOpt: {
      clearable: true,
    },
    events: {
      change: () => { void refreshList() },
    },
    dictData: formatMapToOptions(UpdateStatusText, true),
  },
})
const updateResult = ref(UpdateStatus.Updating)
const formRef = ref()
const timer = ref()
const events = (type: EventType) => {
  const events_types: { [p in EventType]: () => void } = {
    async updateVirusByHand () {
      if (status.value !== UpdateStateType.ToBeUpdated) {
        ElMessage.warning({
          title: '请先在线更新',
          message: '当前已是最新版',
        })
        return
      }
      // 更新前检查网络状态
      const networkOk = await checkNetWork(true)
      if (!networkOk) {
        ElMessageBox.alert('网络连接异常，无法进行在线更新，请检查网络后重试', '网络检测', {
          confirmButtonText: '知道了',
          type: 'warning',
        })
        return
      }
      ElMessageBox.confirm(
        '检测到当前有新版本，是否需要更新?',
        '提示',
        {
          confirmButtonText: '立即更新',
          cancelButtonText: '暂不更新',
          type: 'warning',
        }
      )
        .then(async () => {
          getSampleUpdateOnlineUpdate()
          ElMessageBox.alert(
            '<div class="cm-align-center cm-ui-mb10" style="align-items:flex-start"><i class="is-loading-cms el-icon-refresh" style="color: var(--el-color-primary);font-size: 18px;margin-right: 5px"></i>更新中,完成此操作需要一点时间,请保持网页、电脑开启及网络连接状态顺畅</div>',
            '在线手动更新',
            {
              confirmButtonText: '后台更新',
              dangerouslyUseHTMLString: true,
              'show-close': false
            }
          )
        })
    },
    checkNetWork () {
      void checkNetWork()
    },
    updateVirusByLocal () {
      title.value = '本地上传更新'
      flag.value = true
      isLocal.value = true
      visibleLog.value = true
    },
    reset () {
      form.value = resetForm
      visible.value = false
    },
    async updateVirusByOffLine () {
      title.value = '离线上传更新'
      isLocal.value = false
      flag.value = false
      visibleLog.value = true
    },
    async updateConfig () {
      visible.value = true
      disabled.value = false
      title.value = '自动更新策略'
      form.value = resetForm
      form.value = { ...virusInfo.value } as SubmitVirusRequestParams
    },
    async getVirusInfo () {
      const result = await getVirusDatabaseInfoApi()
      virusInfo.value = result
      virusInfo.value.start_minutes = formatHoursToHoursMinutes(Number(result.start_minutes) / 60)
    },
  }
  events_types[type]()
}
// 更新病毒数据
const refresh = () => {
  events('getVirusInfo')
  void refreshList()
  visibleLog.value = false
}
const handleSubmit: (
  valid: boolean,
  done: () => void,
) => Promise<void> = async (
  valid: boolean,
  done: (ok: boolean) => void
) => {
  if (!valid) return
  disabled.value = true
  const formData: SubmitVirusRequestParams = { ...form.value }
  const formatMinutes = (form.value.start_minutes as string).split(':')
  const minutes = (formatMinutes[0] as unknown as number) * 60 + Number(formatMinutes[1])
  formData.start_minutes = [minutes]
  const result = await updateVirusConfigSourceApi(formData).catch(err => console.log('err', err))
  visible.value = false
  disabled.value = false
  const ok = result?.resp_common?.msg === 'ok'
  done(ok)
  ok && events('getVirusInfo')
}
const getSampleUpdateOfflineVirusStatus = async (task_id: string) => {
  const result: VirusUpdateData = await getSampleUpdateOfflineVirusStatusApi(task_id)
  updateResult.value = result.status
  getSampleUpdateUpdateState()
  if (result.status !== UpdateStatus.Updating) {
    timer.value && clearInterval(timer.value)
    ElMessageBox.close()
    void refreshList()
    ElMessage({
      message: result.status === UpdateStatus.UpdateSuccess ? '更新成功' : '更新失败',
      type: result.status === UpdateStatus.UpdateSuccess ? 'success' : 'error',
    })
  }
}
const getSampleUpdateOnlineUpdate = async () => {
  const result = await getSampleUpdateOnlineUpdateApi()
  timer.value && clearInterval(timer.value)
  if (updateResult.value === UpdateStatus.Updating) {
    timer.value = setInterval(async () => {
      await getSampleUpdateOfflineVirusStatus(result.task_id)
    }, 2000)
  }
}
const getSampleUpdateUpdateState = async () => {
  const result = await getSampleUpdateUpdateStateApi()
  status.value = result.state
}
watch(() => form.value.timing_update_status, (nv, ov) => {
  formColumns.value.frequency.disabled = () => nv === StateType.Rejected
  formColumns.value.start_minutes.disabled = () => nv === StateType.Rejected
  formRef.value?.ruleFormRef?.validateField?.('start_minutes')
})

onMounted(() => {
  events('getVirusInfo')
  getSampleUpdateUpdateState()
})

return (_ctx: any,_cache: any) => {
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_badge = _resolveComponent("el-badge")!
  const _component_CmSvgIcon = _resolveComponent("CmSvgIcon")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_el_drawer = _resolveComponent("el-drawer")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(CmPage, {
      "table-opt": tableOpt,
      modelValue: queryForm.value,
      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((queryForm).value = $event)),
      api: _unref(getSampleUpdateTaskListLogApi),
      "first-loading": true,
      ref_key: "tableRef",
      ref: tableRef,
      "page-option": { style: 'padding-bottom: 16px', pageNumName: 'page_no', pageSizeName: 'page_size' }
    }, {
      header: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_component_el_row, {
            align: "middle",
            justify: "space-between"
          }, {
            default: _withCtx(() => [
              _hoisted_2
            ]),
            _: 1
          }),
          _createVNode(_component_el_row, { style: {"width":"100%","margin-top":"10px"} }, {
            default: _withCtx(() => [
              _createVNode(_component_el_col, {
                style: {"display":"flex","flex-direction":"column","max-width":"200px"},
                lg: {span:4},
                sm: { span: 4 }
              }, {
                default: _withCtx(() => [
                  _hoisted_3,
                  _createElementVNode("div", _hoisted_4, _toDisplayString(virusInfo.value.version || '--'), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, {
                style: {"display":"flex","flex-direction":"column","max-width":"200px"},
                lg: {span:4},
                sm: { span: 4 }
              }, {
                default: _withCtx(() => [
                  _hoisted_5,
                  _createElementVNode("div", _hoisted_6, _toDisplayString(virusInfo.value.window_virus_version || '--'), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, {
                style: {"display":"flex","flex-direction":"column","max-width":"200px"},
                lg: {span:4},
                sm: { span: 4 }
              }, {
                default: _withCtx(() => [
                  _hoisted_7,
                  _createElementVNode("div", _hoisted_8, _toDisplayString(_unref(formatTimeStamp)(virusInfo.value.last_update_time, 'YYYY-MM-DD HH:mm') || '--'), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, {
                style: {"display":"flex","flex-direction":"column"},
                class: "cm-align-center",
                span: 12
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_9, [
                    _hoisted_10,
                    _createVNode(_component_el_button, {
                      type: "text",
                      style: {"padding":"0","min-height":"auto"},
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (events('updateConfig')))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("设置")
                      ]),
                      _: 1
                    })
                  ]),
                  _createVNode(_component_el_row, {
                    align: "middle",
                    style: {"align-self":"flex-start","margin-top":"6px"},
                    class: "label-value"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_tag, {
                        size: "small",
                        type: "success",
                        style: {"height":"auto","border-radius":"25px"}
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(virusInfo.value.timing_update_status === _unref(StateType).Rejected ? '未设置': (_unref(frequencyText)[virusInfo.value.frequency as FrequencyValues] || '--')), 1)
                        ]),
                        _: 1
                      }),
                      (virusInfo.value.timing_update_status === _unref(StateType).Allowed)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_11, _toDisplayString(virusInfo.value.start_minutes || '--'), 1))
                        : _createCommentVNode("", true),
                      (virusInfo.value.timing_update_status === _unref(StateType).Allowed)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_12, "开始执行"))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_el_row, { style: {"align-self":"flex-start","margin-top":"40px"} }, {
            default: _withCtx(() => [
              _createVNode(_component_el_badge, {
                "is-dot": status.value === _unref(UpdateStateType).ToBeUpdated,
                class: "cm-ui-mr10"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_tooltip, {
                    content: "病毒库在线更新前可先点击检查网络是否正常",
                    placement: "top"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_button, {
                        size: "small",
                        type: "primary",
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (events('updateVirusByHand')))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("病毒库在线更新")
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["is-dot"]),
              _createVNode(_component_el_button, {
                size: "small",
                type: "primary",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (events('updateVirusByOffLine')))
              }, {
                default: _withCtx(() => [
                  _createTextVNode("病毒库离线更新")
                ]),
                _: 1
              }),
              _createVNode(_component_el_button, {
                size: "small",
                type: "primary",
                plain: "",
                loading: netChecking.value,
                onClick: _cache[3] || (_cache[3] = ($event: any) => (events('checkNetWork')))
              }, {
                default: _withCtx(() => [
                  _createTextVNode("检测网络")
                ]),
                _: 1
              }, 8, ["loading"])
            ]),
            _: 1
          })
        ]),
        _hoisted_13,
        _createElementVNode("div", _hoisted_14, [
          _createVNode(CmForm, {
            "form-size": _unref(formSize),
            "row-opt": {justify: 'end'},
            modelValue: queryForm.value,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((queryForm).value = $event)),
            formType: _unref(FormActionType).Other,
            "onUpdate:formType": _cache[5] || (_cache[5] = ($event: any) => ((_unref(FormActionType).Other) = $event)),
            "form-columns": QueryFormColumns.value
          }, null, 8, ["form-size", "modelValue", "formType", "form-columns"])
        ])
      ]),
      status: _withCtx(({ value }) => [
        _createElementVNode("div", _hoisted_15, [
          _createElementVNode("div", {
            class: "cm-align-center gap-x-10",
            style: _normalizeStyle({ color: _unref(UpdateStatusColor)[value] })
          }, [
            _createVNode(_component_CmSvgIcon, {
              name: _unref(UpdateStatusIcon)[value],
              size: 14,
              monochrome: "",
              style: {"margin-right":"5px"}
            }, null, 8, ["name"]),
            _createTextVNode(" " + _toDisplayString(_unref(UpdateStatusText)[value]), 1)
          ], 4)
        ])
      ]),
      _: 1
    }, 8, ["table-opt", "modelValue", "api"]),
    _createVNode(_component_el_dialog, {
      title: title.value,
      modelValue: visible.value,
      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((visible).value = $event)),
      width: 300
    }, {
      default: _withCtx(() => [
        _createVNode(CmForm, {
          "form-size": _unref(formSize),
          ref_key: "formRef",
          ref: formRef,
          "form-opt": { 'label-width': 97 },
          disabled: disabled.value,
          "onUpdate:disabled": _cache[7] || (_cache[7] = ($event: any) => ((disabled).value = $event)),
          onSubmit: handleSubmit,
          onReset: _cache[8] || (_cache[8] = ($event: any) => (events('reset'))),
          modelValue: form.value,
          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((form).value = $event)),
          "action-col-opt": { span: 24, style: 'display:flex;justify-content:flex-end;margin-top: 20px' },
          formType: _unref(formType),
          "onUpdate:formType": _cache[10] || (_cache[10] = ($event: any) => (_isRef(formType) ? (formType).value = $event : null)),
          "form-columns": formColumns.value
        }, {
          "start_minutes-label": _withCtx(({ label }:{label?:string}) => [
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("div", {
                style: _normalizeStyle(_unref(formLabelStyle))
              }, _toDisplayString(label), 5),
              _createVNode(_component_el_tooltip, {
                placement: "bottom-start",
                effect: "light",
                trigger: "hover",
                width: 400,
                offset: 0
              }, {
                content: _withCtx(() => [
                  _createElementVNode("strong", null, _toDisplayString(label) + "说明", 1),
                  _hoisted_18,
                  _hoisted_19
                ]),
                default: _withCtx(() => [
                  _hoisted_17
                ]),
                _: 2
              }, 1024)
            ])
          ]),
          "timing_update_status-label": _withCtx(({ label }:{label?:string}) => [
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("div", {
                style: _normalizeStyle(_unref(formLabelStyle))
              }, _toDisplayString(label), 5),
              _createVNode(_component_el_tooltip, {
                placement: "bottom-start",
                effect: "light",
                trigger: "hover",
                width: 400,
                offset: 0
              }, {
                content: _withCtx(() => [
                  _hoisted_22
                ]),
                default: _withCtx(() => [
                  _hoisted_21
                ]),
                _: 1
              })
            ])
          ]),
          _: 1
        }, 8, ["form-size", "disabled", "modelValue", "formType", "form-columns"])
      ]),
      _: 1
    }, 8, ["title", "modelValue"]),
    _createVNode(_component_el_drawer, {
      title: title.value,
      modelValue: visibleLog.value,
      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((visibleLog).value = $event)),
      size: 800
    }, {
      default: _withCtx(() => [
        _createVNode(UpdateVirusVersion, {
          type: isLocal.value,
          onRefresh: refresh
        }, null, 8, ["type"])
      ]),
      _: 1
    }, 8, ["title", "modelValue"])
  ], 64))
}
}

})